var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, FormField, FormGrid, Page, Tooltip, } from '@dixa/lib-shared-habla';
import { useCallback, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { isNumberValidWithReason, numberFormatterE164, } from 'app/utils/telephonyHelpers';
import { HookFormText } from 'components/hookForm';
import { userModalActions, } from 'components/usersModal';
import { validateName } from 'utils/formValidator';
import { useBreakpointValue } from 'utils/mediaQuery';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useCurrentUser } from 'utils/user';
import { settingsProfileFormId } from '../../profileForm';
import { ProfileAvatarControl } from './components/avatarControl/profileAvatarControl';
import { ProfileDesktopAppLink } from './components/desktopAppLink/profileDesktopAppLink';
export const ProfileFormInfo = () => {
    const dispatch = useAppDispatch();
    const { user } = useCurrentUser();
    const isSmallScreen = useBreakpointValue({ base: true, md: false });
    const { control, formState, setError } = useFormContext();
    const phoneNumber = useWatch({ control, name: 'phone_number' });
    const handlePhoneNumberBlur = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!phoneNumber)
            return true;
        try {
            const { available, conflicting_id } = (yield dispatch(userModalActions.validation.phoneNumber(numberFormatterE164({
                phoneNumber: phoneNumber.replace(/\s/g, ''),
            })))).payload;
            if (!available && conflicting_id !== user.id) {
                setError('phone_number', {
                    type: 'manual',
                    message: 'Phone number is already used by another user',
                });
            }
        }
        catch (error) { }
    }), [dispatch, phoneNumber, setError, user.id]);
    const scimTooltipProps = useMemo(() => ({
        content: 'You cannot edit this field because the information is coming from another system.',
        disabled: !user.has_scim_enabled,
        dark: true,
    }), [user]);
    return (_jsxs(Page.Section, Object.assign({ title: "Profile info", controls: _jsxs(_Fragment, { children: [_jsx(Box, Object.assign({ padding: "0 300" }, { children: _jsx(ProfileDesktopAppLink, {}) })), _jsx(Button, Object.assign({ type: "submit", form: settingsProfileFormId, isLoading: formState.isSubmitting, disabled: !formState.isDirty || !formState.isValid || formState.isSubmitting }, { children: "Save changes" }))] }) }, { children: [_jsx(ProfileAvatarControl, {}), _jsxs(FormGrid, { children: [_jsx(FormField, Object.assign({ span: isSmallScreen ? 6 : 3 }, { children: _jsx(Tooltip, Object.assign({}, scimTooltipProps, { children: _jsx(HookFormText, { name: "given_name", label: "First name", control: control, rules: {
                                    required: 'First name is required',
                                    validate: validateName,
                                }, componentProps: {
                                    placeholder: 'First name',
                                    readOnly: user.has_scim_enabled,
                                } }) })) })), _jsx(FormField, Object.assign({ span: isSmallScreen ? 6 : 3 }, { children: _jsx(Tooltip, Object.assign({}, scimTooltipProps, { children: _jsx(HookFormText, { name: "family_name", label: "Last name", control: control, rules: {
                                    required: 'Last name is required',
                                    validate: validateName,
                                }, componentProps: {
                                    placeholder: 'Last name',
                                    readOnly: user.has_scim_enabled,
                                } }) })) })), _jsx(FormField, Object.assign({ span: 6 }, { children: _jsx(HookFormText, { name: "name", label: "Display name", control: control, rules: {
                                required: 'Display name is required',
                                validate: validateName,
                            }, componentProps: {
                                placeholder: 'Display name',
                            } }) })), _jsx(FormField, Object.assign({ span: isSmallScreen ? 6 : 3 }, { children: _jsx(Tooltip, Object.assign({}, scimTooltipProps, { children: _jsx(HookFormText, { name: "phone_number", label: "Phone number", control: control, rules: {
                                    validate: {
                                        isValid: (phoneNumber) => phoneNumber
                                            ? isNumberValidWithReason({ phoneNumber })
                                            : true,
                                    },
                                }, componentProps: {
                                    type: 'tel',
                                    placeholder: 'e.g. +1 205-832-1018',
                                    onBlur: handlePhoneNumberBlur,
                                    readOnly: user.has_scim_enabled,
                                } }) })) })), _jsx(FormField, Object.assign({ span: isSmallScreen ? 6 : 3 }, { children: _jsx(HookFormText, { name: "email", label: "Email", control: control, rules: {
                                required: 'Email is required',
                            }, componentProps: {
                                type: 'email',
                                placeholder: 'john@example.com',
                                readOnly: true,
                            } }) }))] })] })));
};
